import React, { useEffect } from "react";

const PaymentSuccess = () => {
    useEffect(() => {
        // Try to launch the app immediately
        document.getElementById("launchApp").click();

        // Fallback setTimeout in case immediate redirect doesn't work
        const timer = setTimeout(() => {
            document.getElementById("launchApp").click();
        }, 1000);

        // Cleanup timer on component unmount
        return () => clearTimeout(timer);
    }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50 px-4">
      <div className="bg-white max-w-md w-full p-6 sm:p-10 rounded-2xl shadow-xl text-center animate-fade-in">
        <div className="flex items-center justify-center mb-6">
          <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-green-100 flex items-center justify-center animate-bounce-slow">
            <svg
              className="w-12 h-12 sm:w-14 sm:h-14 text-green-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        <h2 className="text-xl sm:text-2xl font-semibold text-green-600 mb-2">Payment Successful!</h2>
        <p className="text-gray-600 text-sm sm:text-base">
          Thank you for your purchase. Your payment has been processed successfully.
        </p>
      </div>
      <a id="launchApp" href="e2t://com.educate2trade.e2t/open?value=success" style={{display: "none"}}></a>

      <style>
        {`
          @keyframes fade-in {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }

          .animate-fade-in {
            animation: fade-in 0.6s ease-out;
          }

          @keyframes bounce-slow {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }

          .animate-bounce-slow {
            animation: bounce-slow 1.4s infinite;
          }
        `}
      </style>
    </div>
  );
};

export default PaymentSuccess;
